import React from "react";
import "./SmartSavingsModal.css";
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { WEB } from "../../../constants/AppConstants";
import { updateUserNotificationConsentStateRequest } from "../../../store/brotherPlus/UserNotificationConsent/UpdateUserNotificationConsentStateSlice";
import { buildConsentPayload } from "../../../utils/consentService";

const SmartSavingsModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['translation']);
  const handleEnable = () => {
       const {payload}=buildConsentPayload({
        userConsent : { emailConsent:true} , enrolmentSource:WEB
      })
    dispatch(updateUserNotificationConsentStateRequest(payload))
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };
  return (
    <div className="modal-overlay-smartsavings">
      <div className="modal-content-smartsavings">
        <div className="modal-smartsavings-title"> {t('BROTHER_PLUS.SMART_SAVINGS.HEADER')}</div>
        <p className="modal-smartsavings-subtitle">{t('CONNECT_DASHBOARD.SMART_SAVINGS.SUB_TITLE')}</p>
        <p className="subtext">{t('CONNECT_DASHBOARD.SMART_SAVINGS.CONTENT')}</p>
        <div className="modal-buttons">
          <button className="cancel-btn" onClick={handleCancel}>{t('CONNECT_DASHBOARD.SMART_SAVINGS.CANCEL')}</button>
          <button className="enable-btn" onClick={handleEnable}>{t('CONNECT_DASHBOARD.SMART_SAVINGS.TITLE')}</button>
        </div>
      </div>
    </div>
  );
};

export default SmartSavingsModal;
